import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-refund-bill-item.reducer';

export const PharmacyRefundBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyRefundBillItemEntity = useAppSelector(state => state.pharmacyRefundBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyRefundBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.detail.title">PharmacyRefundBillItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.id}</dd>
          <dt>
            <span id="chargedMrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.chargedMrp">Charged Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.chargedMrp}</dd>
          <dt>
            <span id="refundPaid">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.refundPaid">Refund Paid</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.refundPaid}</dd>
          <dt>
            <span id="refundQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.refundQty">Refund Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.refundQty}</dd>
          <dt>
            <span id="soldQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.soldQty">Sold Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.soldQty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.expDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.lastupdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.pharmacyStock">Pharmacy Stock</Translate>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.pharmacyStock ? pharmacyRefundBillItemEntity.pharmacyStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.saleBillItem">Sale Bill Item</Translate>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.saleBillItem ? pharmacyRefundBillItemEntity.saleBillItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.refundBill">Refund Bill</Translate>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.refundBill ? pharmacyRefundBillItemEntity.refundBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.saleBill">Sale Bill</Translate>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.saleBill ? pharmacyRefundBillItemEntity.saleBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.returnBill">Return Bill</Translate>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.returnBill ? pharmacyRefundBillItemEntity.returnBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBillItem.returnItem">Return Item</Translate>
          </dt>
          <dd>{pharmacyRefundBillItemEntity.returnItem ? pharmacyRefundBillItemEntity.returnItem.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-refund-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-refund-bill-item/${pharmacyRefundBillItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyRefundBillItemDetail;
